<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>考勤查询</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="2">
          <el-input size="small" style="width:98%;margin-bottom:10px" v-model="searchName" placeholder="请输入姓名"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input size="small" style="width:98%;margin-right:1px;" v-model="searchUserCode" placeholder="请输入工号"></el-input>
        </el-col>
        <el-col :span="2">
          <el-input size="small" style="width:98%;" v-model="searchMainName" placeholder="请输入部门"></el-input>
        </el-col>
        <el-col :span="2">
            <el-date-picker style="width:98%;"  v-model="startTime" size="small" type="date" placeholder="选择日期"></el-date-picker>
        </el-col>
        <el-col :span="2">
            <el-date-picker style="width:98%;"  v-model="endTime" size="small" type="date" placeholder="选择日期"> </el-date-picker>
        </el-col>
        <el-col :span="1">
            <el-button type="primary" size="small" @click="SearchByName" plain>搜索</el-button>
        </el-col>
        <el-col :span="1">
            <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
        </el-col>
        <el-col :span="12">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="TableData" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="userName" label="姓名"></el-table-column>
            <el-table-column prop="userCode" label="工号"></el-table-column>
            <el-table-column prop="mainDeptsName" label="部门"></el-table-column>
            <el-table-column prop="workDate" label="工作日"></el-table-column>
            <el-table-column prop="checkType" label="考勤类型"></el-table-column>
            <el-table-column prop="timeResult" label="打卡结果">
                <template slot-scope="scope">
                    <div :class="scope.row.timeResult=='正常'?'':'redfont'">{{scope.row.timeResult}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="userCheckTime" label="打卡时间"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { GeteAttendanceSearch } from "../../until/ZeusApiSDK/Logic/AttendanceListLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
export default {
  data() {
    return {
      searchName: "",//姓名
      searchUserCode:'',//工号
      searchMainName:'',//部门
      startTime:'',//开始时间
      endTime:'',//结束时间
      TableData: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      currentRole:{},//当前登录角色
      currentUser:{},//当前登录人
    };
  },
  created() {
    //获取当前用户角色
    this.getCurrentRole()
    //获取当前用户
    this.getCurrentUser();

    this.GetAttendancePageList();
  },
  methods: {

    //新增api接口
    // addApi:function(){
    //   this.$router.push('/Api/EditApi');
    // },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetAttendancePageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetAttendancePageList();
    },
    SearchByName: function() {
      this.pageIndex = 1;
      this.GetAttendancePageList();
    },
    Refresh:function(){
      this.GetAttendancePageList();
    },
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole:function(){
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    GetAttendancePageList: function() {
      this.loading = true;
      console.log('this.currentUser',this.currentUser);
      console.log('this.currentRole',this.currentRole);
      //开始时间
      if(this.startTime!=''&&this.startTime!=null){
        const contractStart = new Date(this.startTime);
        const contractStartTime = contractStart.getFullYear() + '-' + this.p((contractStart.getMonth() + 1)) + '-' + this.p(contractStart.getDate());
        this.startTime=contractStartTime;
      }
      //结束时间
      if(this.endTime!=''&&this.endTime!=null){
        const contractEnd = new Date(this.endTime);
        const contractEndTime = contractEnd.getFullYear() + '-' + this.p((contractEnd.getMonth() + 1)) + '-' + this.p(contractEnd.getDate());
        this.endTime=contractEndTime;
      }
      GeteAttendanceSearch(
        this.pageIndex,
        this.pageSize,
        this.currentRole.Key,
        this.currentUser.UserId,
        this.startTime,
        this.endTime,
        this.searchMainName,
        this.searchName,
        this.searchUserCode
      ).then(pageRes => {
        console.log('pageRes',pageRes);
        this.TableData = pageRes.List;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    //时间转换 不够10 添加0
    p(s) {
        return s < 10 ? '0' + s : s
    }
  }
};
</script>
<style lang="less" scoped>
    .redfont{
        color:red;
    }
</style>